import moment from "moment";
import React, { useState } from "react";
import { FaRegStar } from "react-icons/fa";
import ratingModel from "../../model/rating.model";
import { toast } from "../../lib/helper";
import { IoCloseCircle } from "react-icons/io5";
import rating from "../../Asset/ordercard/rating.jpg";
import { FaStar } from "react-icons/fa";
import { MdRateReview } from "react-icons/md";

const Orderdetaildata = ({ datalist, Get }) => {
  const [productid, setProductid] = useState();
  const [ratingon, setRatingOn] = useState(false);
  const [star, setStar] = useState("");

  const RatingProduct = async (e) => {
    e.preventDefault();
    const form = new FormData(e.target);
    form.append("rating", star);
    form.append("product_id", productid);
    ratingModel
      .Rate(form)
      .then((responce) => {
        toast(responce?.data?.message, "success");
        Get();
        setRatingOn(false);
      })
      .catch((error) => {
        console.log("abcd", error);
        toast(error?.response?.data?.message, "warning");
      });
  };
console.log("checking full",datalist)
  return (
    <div className="w-full p-4 bg-Background1 rounded-3xl">
      <div className="flex justify-between items-start">
        <div>
          {" "}
          <span className="title1">Order: #{datalist?._id}</span>
        </div>
        <span className="text-xs title2 text-[#909090]">
          Ordered on{" "}
          {moment(datalist?.createdAt).format("DD MMM YYYY, hh:mm A")}
        </span>
      </div>
      <div className="flex justify-between items-start mt-1">
        <div>
          {" "}
          <span className="text-base font-bold title2">Total ₹ {datalist?.total}</span>
        </div>
        <span className="text-textColor text-sm font-semibold bg-[#DCE5D6] px-2 py-0.5 rounded-lg">
          Shipped
        </span>
      </div>
      <div className="flex mt-1">
        <span className="font-semibold text-base title2">{datalist?.order_type} For {" "}</span>10 Feb 2025
      </div>
      <div className="mt-1">
        {datalist?.items?.map((item, index) => {
          
          return (
            <div className="flex flex-col mt-2" key={index}>
              <div className="flex justify-between">
                <div className=" flex gap-5">
                  <div className="w-16 h-16 rounded-md">
                    <img
                      src={item?.product_id?.profile_image?.location}
                      alt="img"
                      className="w-full h-full object-cover rounded-md"
                    />
                  </div>
                  <div className="flex flex-col">
                    <span className="title1">{item?.product_id?.name}</span>
                    <span className="title2 font-bold text-[#8F8F8F]">
                      {item?.product_id?.quantity} {item?.product_id?.unit_type}
                    </span>
                  </div>
                </div>
                <div>
                  <div className="bg-white flex gap-3 items-center justify-center px-3 rounded-2xl py-0.5">
                    <span className="title2 text-gray-500">Qty</span>
                    <div className=" bg-[#DCE5D6] text-gray-600 rounded-full w-8 h-8 flex items-center justify-center">
                      {item?.quantity}
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-2">
                <span
                  className="bg-white text-[#595959] title2 text-[13px] px-5 py-1 rounded-xl flex items-center gap-1 whitespace-nowrap cursor-pointer"
                  onClick={() => {
                    setRatingOn(true);
                    setProductid(item?.product_id?._id);
                    setStar(item?.product_rating?.rating);
                  }}
                >
                  Add Review{" "}
                  {[1, 2, 3, 4, 5].map((starIndex) =>
                    item?.product_rating?.rating >= starIndex ? (
                      <FaStar key={starIndex} className="text-[#D7C823]" />
                    ) : (
                      <FaRegStar key={starIndex} className="text-[#D7C823]" />
                    )
                  )}
                </span>
              </div>
            </div>
          );
        })}
      </div>
      {ratingon && (
        <div
          className="w-full h-screen  bg-black/50 fixed inset-0 z-50 flex justify-center items-center"
          onClick={() => {
            setRatingOn(false);
          }}
        >
          <div
            className="bg-Background10 pl-5 pr-5 pt-3 pb-0 w-11/12  md:w-2/4 lg:w-1/3 xl:w-[30%] h-[90%] relative rounded-3xl"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="flex justify-end ">
              <span className="text-3xl">
                <IoCloseCircle
                  className="cursor-pointer"
                  onClick={() => {
                    setRatingOn(false);
                  }}
                />
              </span>
            </div>
            <div className="px-6 lg:px-4 xl:px-6 py-0 w-full h-full flex flex-col justify-between items-center rounded-3xl">
              <form onSubmit={RatingProduct}>
                <div className="w-full flex flex-col ">
                  <span className="title1 text-textColor flex  gap-2 text-xl lg:text-xl xl:text-2xl">
                    <MdRateReview className="text-4xl text-textcolor2"/>How much will you rate this product ?
                  </span>

                  <div className="mt-3 xl:mt-6 text-2xl lg:text-xl xl:text-2xl flex gap-3">
                    {[1, 2, 3, 4, 5].map((starIndex) => {
                      const isFilled = star >= starIndex;

                      return isFilled ? (
                        <FaStar
                          key={starIndex}
                          className="text-[#D7C823] cursor-pointer"
                          onClick={() =>
                            setStar(star === starIndex ? "" : starIndex)
                          }
                        />
                      ) : (
                        <FaRegStar
                          key={starIndex}
                          className="text-[#D7C823] cursor-pointer"
                          onClick={() => setStar(starIndex)}
                        />
                      );
                    })}
                  </div>
                  <div className="mt-5 xl:mt-8 text-2xl flex flex-col w-full">
                    <span className="title1 text-textColor  text-text-2xl lg:text-xl xl:text-2xl">
                      Write Your Opinion
                    </span>
                    <textarea
                      row={4}
                      name="review"
                      className="mt-5 w-full h-40 lg:h-20 xl:h-30 text-[12px] p-3 rounded-xl "
                      placeholder="Write here"
                    />
                  </div>
                  <div className="w-full  text-white mt-5 xl:mt-10">
                    <button
                      className="flex items-center justify-center py-1.5 font-semibold rounded-xl bg-textColor w-full"
                      type="submit"
                    >
                      Submit Review
                    </button>
                  </div>
                  <div className="mt-6 xl:mt-6 2xl:mt-12 w-full">
                    <span className="w-full flex text-Background6 title1 text-[12px] lg:text-xs xl:text-sm">
                      Your review helps others make the best choice and lets us
                      know how we're doing. Drop a few lines about what you
                      loved.
                    </span>
                  </div>
                </div>
              </form>
              <div className="w-full flex bg-yellow-100 absolute bottom-0 rounded-3xl">
                <img
                  src={rating}
                  alt="img"
                  className=" flex w-full h-auto object-cover rounded-3xl"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Orderdetaildata;
